import React from 'react'
import {
  DialogActions,
  Button,
  DialogContent,
  IconButton,
  Dialog,
  DialogTitle,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { RichTextField } from '@prismicio/types'

import CMSText from '@/components/Global/CMSText'

type Props = {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  title: string
  body?: RichTextField
  children?: React.ReactNode
  confirmText: RichTextField
  confirmButtonDisabled?: boolean
}

export const ConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  body,
  confirmText,
  children,
  confirmButtonDisabled = false,
}: Props) => (
  <Dialog
    open={open}
    onClose={onClose}
    PaperProps={{
      elevation: 0,
      square: true,
      className: 'take-back-confirmation-modal__container',
    }}
  >
    <DialogTitle className={'take-back-confirmation-modal__title'}>
      <CMSText data={title} asText />

      <IconButton
        className={'take-back-confirmation-modal__closeButton'}
        onClick={onClose}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>

    <DialogContent className={'take-back-confirmation-modal__body'}>
      {body && <CMSText data={body} />}
      {children}
    </DialogContent>

    <DialogActions className={'take-back-confirmation-modal__actions'}>
      <Button
        className={'take-back-confirmation-modal__actionButton'}
        onClick={onConfirm}
        disabled={confirmButtonDisabled}
      >
        <CMSText asText data={confirmText} />
      </Button>
    </DialogActions>
  </Dialog>
)
